import React, { useState, useEffect } from 'react';
import { Drawer, Card, Button, Form, Row, Col, Input, Icon } from 'antd';
import { formItemLayout, InputBox } from '../../../../components/_utils/appUtils';
import { useDispatch } from 'react-redux';
import GetEachFormFields from '../../../../components/_utils/appFormUtils'; // Ensure this matches your working import
import moment from 'moment';
import {UpdateAbstractReceiveDate} from '../actions/index'

const EAbstractReceiveDate = (props) => {
  let { visible, onClose, abstract, reviewerId, form: { getFieldDecorator, setFieldsValue } } = props;
  let [articleAttachment, setArticleAttachment] = useState({});
  let [commentsAttachment, setCommentsAttachment] = useState({});
  let [attachment, setAttachment] = useState({ articleAttachment: '', commentsAttachment: '' });
  const dispatch = useDispatch();

  useEffect(() => {
    setDefaultData();
  }, [visible]);

  let setDefaultData = () => {
    let reviewer = abstract.selectedReviewer.find(r => r.reviewerId._id === reviewerId);
    if (reviewer) {
      setTimeout(() => {
        setFieldsValue({ receiveDate: reviewer.receiveDate ? moment(reviewer.receiveDate) : null });
      }, 500);

      setAttachment({
        articleAttachment: (reviewer.abstractAttachment && reviewer.abstractAttachment.path) ? reviewer.abstractAttachment.path : '',
        commentsAttachment: (reviewer.abstractcommentsAttachment && reviewer.abstractcommentsAttachment.path) ? reviewer.abstractcommentsAttachment.path : ''
      });
    }
  };

  const chooseDocument = (e) => {
    let { name, files } = e.target;
    if (files && files.length) {
      if (name === 'commentsAttachment') setCommentsAttachment(files[0]);
      if (name === 'articleAttachment') setArticleAttachment(files[0]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    props.form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let fd = new FormData();
        let obj = { ...valData, abstractId: abstract._id, reviewerId };

        fd.append('obj', JSON.stringify(obj));

        // Append attachments only if they exist
        if (articleAttachment.name) fd.append('abstractAttachment', articleAttachment);
        if (commentsAttachment.name) fd.append('abstractcommentsAttachment', commentsAttachment);

        let { success } = await dispatch(UpdateAbstractReceiveDate(fd));

        if (success) {
          dispatch({ type: 'START_LOAD_ABSTRACT' }); // Ensure this action type matches your reducer
          onClose();
        }
      }
    });
  };
  const inputSchema = {
    fields: [
      {
        label: 'Receive Date',
        key: 'receiveDate',
        type: 'date',
        required: true,
        placeholder: 'Receive Date'
      },
      {
        label: 'Comments attachment',
        customField: (
          <InputBox title={`Comments attachment*`} className={'rowFlex'}>
            <Input
              type={'file'}
              name={'commentsAttachment'}
              className={'form-control'}
              onChange={chooseDocument}
            />
            {attachment.commentsAttachment ? (
              <a className={'linkBtn'} target={'_blank'} href={attachment.commentsAttachment} rel="noreferrer">
                <Icon type={'eye'} />
              </a>
            ) : null}
          </InputBox>
        )
      },
      {
        label: 'Abstract attachment',
        customField: (
          <InputBox title={`Abstract attachment*`} className={'rowFlex'}>
            <Input
              type={'file'}
              name={'articleAttachment'}
              className={'form-control'}
              onChange={chooseDocument}
            />
            {attachment.articleAttachment ? (
              <a className={'linkBtn'} target={'_blank'} href={attachment.articleAttachment} rel="noreferrer">
                <Icon type={'eye'} />
              </a>
            ) : null}
          </InputBox>
        )
      }
    ]
  };
  return (
    <Drawer title={'Edit Abstract Receive Date'} width={'65%'} visible={visible} placement="right" onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={8} key={key}>
                {item.customField ? item.customField : (
                  <GetEachFormFields
                    getFieldDecorator={getFieldDecorator}
                    item={item}
                    formItemLayout={formItemLayout}
                  />
                )}
              </Col>
            ))}
            <Col span={24}>
              <Form.Item>
                <Button type='primary' htmlType='submit'>Submit</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  );
};

export default Form.create()(EAbstractReceiveDate);
